
/* eslint-disable vue/no-mutating-props --
 * TagMultiPicker is intentionally an in-place editor on a reactive tagSets array the
 * parent owns. The parent reads state.tagSets / parent.tagSets directly in its save path,
 * so emit-and-replace would mean the parent reassigns its own state field on every edit
 * and nested parent components (addParentTagSet) would need their own forwarding plumbing.
 * The design chose in-place mutation; this comment disables the lint for the whole file.
 */
import { defineComponent, PropType } from "vue";
import VueFeather from "vue-feather";
import { TagSetDraft } from "./tasksConfigTypes";

export default defineComponent({
  name: "TagMultiPicker",
  components: { VueFeather },
  props: {
    tagSets: {
      type: Array as PropType<TagSetDraft[]>,
      required: true,
    },
    sensorTagOptions: {
      type: Object as PropType<Record<string, string[]>>,
      required: true,
    },
    // Appended to :key so simultaneous instances don't collide.
    keyPrefix: {
      type: String,
      default: "",
    },
    // Woven into aria-labels on remove buttons so screen readers can tell
    // multiple pickers on the same page apart (e.g. "on parent P1").
    ariaContext: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const filteredTagOptionsForSet = (draft: TagSetDraft): string[] =>
      Object.keys(props.sensorTagOptions)
        .filter((a) => !(a in draft.tags))
        .sort((a, b) => (a > b ? 1 : -1));

    const addRuleTag = (draft: TagSetDraft) => {
      draft.tags[draft.selectTag] = draft.selectTagValue;
      draft.selectTag = "";
      draft.selectTagValue = "";
    };

    const addTagSet = () => {
      props.tagSets.push({ tags: {}, selectTag: "", selectTagValue: "" });
    };

    const removeTagSet = (index: number) => {
      props.tagSets.splice(index, 1);
    };

    const removeTag = (draft: TagSetDraft, key: string) => {
      delete draft.tags[key];
    };

    const conditionAriaLabel = (idx: number): string =>
      props.ariaContext
        ? `Remove condition ${idx + 1} ${props.ariaContext}`
        : `Remove condition ${idx + 1}`;

    const tagAriaLabel = (key: string): string =>
      props.ariaContext ? `Remove tag ${key} ${props.ariaContext}` : `Remove tag ${key}`;

    return {
      filteredTagOptionsForSet,
      addRuleTag,
      addTagSet,
      removeTagSet,
      removeTag,
      conditionAriaLabel,
      tagAriaLabel,
    };
  },
});
